import React from "react";
import {
    Grid,
    Typography,
    Tooltip,
} from "@mui/material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";

interface ITextInfoItem {
    value?: string | number | string[];
    locaId?: IdlocaGeneric;
    icon?: React.ReactNode;
    toolTipLocaId?: IdlocaGeneric;
    renderer?: JSX.Element;
}

export const TextInfoItem: React.FC<ITextInfoItem> = ({
    locaId,
    value,
    icon,
    toolTipLocaId,
    renderer,
}) => {
    return (
        <Grid container spacing={1}>
            <Grid item
                xs={12}
                sx={{
                    display: "flex",
                    alignItems: "center",
                }}>
                {icon && (
                    <Grid item sx={{marginRight: 1}}>
                        <Tooltip title={toolTipLocaId ? <Locale localeId={toolTipLocaId}/> : ""} arrow>
                            <div style={{
                                color: "#9e9e9e",
                                fontSize: "20px",
                            }}>
                                {icon}
                            </div>
                        </Tooltip>
                    </Grid>
                )}
                {locaId && (
                    <Typography variant="caption" color="textSecondary" style={{marginRight: 10}}>
                        <Locale localeId={locaId}/>:
                    </Typography>
                )}
                <Typography variant="caption"
                    style={{
                        fontWeight: 600,
                        color: "#333",
                        lineHeight: "20px",
                    }}>
                    {renderer ?? value ?? "N/A"}
                </Typography>
            </Grid>
        </Grid>
    );
};
